import type { RenderTarget } from "@shopify/flash-list";
import { View } from "react-native";
import native from "src/constants/native";
import useGatheringPublicFullBodySpacing from "../hooks/useGatheringPublicFullBodySpacing";
import { GatheringPublicFullBodyRow } from "../types";
import GatheringPublicFullPhoto from "./GatheringPublicFullPhoto";

const GatheringPublicFullRow = ({
	row,
	itemWidth,
	target,
}: {
	row: GatheringPublicFullBodyRow;
	itemWidth: number;
	target: RenderTarget;
}) => {
	const { containerHorizontalPadding, halfSpacing, horizontalPadding, spacing } =
		useGatheringPublicFullBodySpacing();
	const height = (4 / 3) * itemWidth;
	return (
		<View
			style={{
				width: "100%",
				height,
				paddingHorizontal: containerHorizontalPadding,
				flexDirection: "row",
				justifyContent: "space-between",
				marginVertical: halfSpacing,
			}}
		>
			{(native || target !== "Measurement") &&
				row.data.map((item) => {
					const { variant } = item;
					switch (variant) {
						case "Photo":
							return (
								<GatheringPublicFullPhoto
									key={item.itemKey}
									photo={item.photo}
									sticker={item.sticker}
									width={itemWidth}
									height={height}
								/>
							);
						case "Empty":
							return (
								<View
									key={item.itemKey}
									style={{
										width: itemWidth,
										height,
									}}
								/>
							);
					}
				})}
		</View>
	);
};
export default GatheringPublicFullRow;
